'use strict';

module.exports = {
    /**
     * 获取地理位置接口
     * @method hysdk.getLocation
     * @category Fusion:Device
     * @description
     * * timeout 单位为 ms，默认为 30000。
     * * type 只支持 gps 火星坐标， 不支持 baidu。
     */
    getLocation: {
        service: 'Locate',
        action: 'locate',
        tagname: 'locate',
        optHandle: function optHandle(opt) {
            if (opt.timeout) {
                opt.timeout = (parseInt(opt.timeout) || 30) * 1000;
            }
            return opt;
        },
        resHandle: function resHandle(res) {
            var rs = {};
            if (res.value) {
                rs.type = 'gps';
                rs.coords = {
                    latitude: res.value.lat,
                    longitude: res.value.lng,
                    accuracy: 1
                };
            }
            return rs;
        }
    },
    /**
     * 使用经纬度打开本地地图<br />
     * @method hysdk.openLocation
     * @category Fusion:Device
     * @description
     * 支持 latitude 和 longitude 参数，其他参数平台各异。
     */
    openLocation: {
        service: 'Locate',
        action: 'showMap',
        tagname: 'show_map'
    },
    /**
     * 获取设备信息
     * @method hysdk.getDeviceInfo
     * @category Fusion:Device
     * @description
     * 信息内容平台各异
     */
    getDeviceInfo: {
        exec: function exec(opt, callback) {
            callback(JSON.parse(window.name));
        }
    },
    /**
     * 获取网络状态
     * @method hysdk.getNetworkType
     * @category Fusion:Device
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    getNetworkType: {
        service: 'Util',
        action: 'checkNetworkStatus',
        tagname: 'check_network_status',
        resHandle: function resHandle(res) {
            return {
                networkType: res.networkType.toLowerCase()
            };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/device.js
// module id = 44
// module chunks = 1 4